module.exports = {
      id: "corona-updates-icon-usage",
      viewBox: "0 0 25.374 25.18",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#corona-updates-icon",
      toString: function () {
        return this.url;
      }
    }